import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  trainingHistory: [],
  training: {},
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  trainingHistoryListGet: (state) => state.trainingHistory,
  trainingGet: (state) => state.training,
  paginationGet: (state) => state.pagination,
  trainingCourseListGet: (state) =>
    state.trainingHistory.map((item) => ({
      id: item.id,
      courseName: item.course,
    })),
};
const actions = {
  getTrainingHistory({ commit }, payload) {
    console.log(payload.isModal, "isModal");

    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`training-history?page=${page}`).then(
      (obj) => {
        var result = obj.data.data;
        const pageresult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: 50,
          total: obj.data.total,
        };
        commit("trainingHistoryListSet", result);
        commit("setPagination", pageresult);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getTrainingById({ commit }, payload) {
    service.getFun(`training-history/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("trainingHistoryById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addTraining({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `training-history`, null, {
        action: "getTrainingHistory",
      })
      .then(
        (result) => {
          commit("addTrainingStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editTraining({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `training-history/${payload.id}`,
        null,
        {
          action: "getTrainingHistory",
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editTrainingStatus", result.success);
            toast(result.message);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async deleteTraining({ commit }, payload) {
    const result = await service.deleteFun(
      `training-history/${payload.payload}`,

      {
        action: "getTrainingHistory",
        page: store.state.page.page,
      }
    );
    if (result) {
      commit("deleteCourseStatus", result.success);
      toast(result.message);
    } else {
      commit("deleteCourseStatus", false);
    }
  },
};
const mutations = {
  trainingHistoryListSet(state, trainingHistory) {
    state.trainingHistory = trainingHistory;
  },
  addTrainingStatus(state, Status) {
    state.addStatus = Status;
  },
  trainingHistoryById(state, training) {
    state.training = training;
  },
  editTrainingStatus(state, Status) {
    state.addStatus = Status;
  },
  deleteTrainingStatus(state, Status) {
    state.addStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
